import { useQuery } from '@apollo/client';
import {
  FETCH_EMBEDDED_GOAL_WORKFLOW,
  type FetchEmbeddedGoalWorkflowQuery,
} from '@ovComponents/4-module/goalCard/embeddedGoalWorkflow.queries';
import type {
  EmbeddedWorkflowResolutionStatus,
  WorkflowSubStepsDefinition,
} from '@ovComponents/4-module/goalCard/goalRiskQuestionConfig';

export const getEmbeddedGoalWorkflowId = (
  goalWorkflow?: string,
): string | undefined => {
  if (!goalWorkflow || goalWorkflow === 'default') {
    return undefined;
  }
  return goalWorkflow;
};

export const useEmbeddedGoalWorkflow = (
  goalWorkflow?: string,
): {
  workflow: WorkflowSubStepsDefinition | null;
  status: EmbeddedWorkflowResolutionStatus;
} => {
  const workflowId = getEmbeddedGoalWorkflowId(goalWorkflow);
  const { data, loading, error } = useQuery<FetchEmbeddedGoalWorkflowQuery>(
    FETCH_EMBEDDED_GOAL_WORKFLOW,
    {
      variables: { workflowId },
      skip: !workflowId,
      fetchPolicy: 'cache-first',
    },
  );

  const status: EmbeddedWorkflowResolutionStatus = !workflowId
    ? 'idle'
    : loading
      ? 'loading'
      : error
        ? 'error'
        : 'ready';

  return {
    workflow: data?.fetchWorkflow?.workflow ?? null,
    status,
  };
};
